import type React from "react";

interface ClientErrorMessageProps {
	message: string | React.ReactNode;
	className?: string;
}

const ClientErrorMessage: React.FC<ClientErrorMessageProps> = ({
	message,
	className = "bg-moss-green-80 mx-auto flex flex-col items-center justify-center min-h-screen w-full relative overflow-hidden",
}) => {
	return (
		<div className={className}>
			{/* Logo-only header */}
			<div className="fixed top-4 left-0 w-full z-50">
				<div className="relative mx-auto w-full max-w-7xl bg-white/20 backdrop-blur-sm shadow-md flex items-center justify-starts h-16 px-4 py-9 sm:px-6 md:px-8 md:rounded transition-all">
					<img
						className="w-auto h-16"
						src="/assets/logo/logo-white.svg"
						alt="Howden Logo"
					/>
				</div>
			</div>

			{/* Decorative background circles */}
			<div className="absolute bottom-[-300px] right-5 w-[400px] h-[400px] rounded-full bg-teal opacity-50 blur-xl animate-[float_15s_ease-in-out_2s_infinite]"></div>

			<div className="absolute bottom-[160px] right-[450px] w-[100px] h-[100px] rounded-full bg-pistachio opacity-60 blur-xl animate-[diagonal_16s_ease-in-out_1s_infinite]"></div>

			<div className="absolute bottom-[-80px] left-[-100px] w-[400px] h-[400px] rounded-full bg-pistachio opacity-40 blur-xl animate-[floatX_12s_ease-in-out_0.5s_infinite]"></div>

			<div className="absolute top-[100px] left-[40%] w-[180px] h-[180px] rounded-full bg-teal opacity-40 blur-lg animate-[floatX_9s_ease-in-out_0.7s_infinite]"></div>

			<div className="absolute bottom-[20%] right-[30%] w-[180px] h-[180px] rounded-full bg-teal opacity-40 blur-lg animate-[floatX_9s_ease-in-out_0.7s_infinite]"></div>

			<div className="absolute top-[40%] right-[10%] w-[150px] h-[150px] rounded-full bg-pistachio opacity-30 blur-lg animate-[float_11s_ease-in-out_2.5s_infinite_reverse]"></div>

			<div className="absolute top-[60%] right-[15%] w-[90px] h-[90px] rounded-full bg-teal opacity-35 blur-md animate-[diagonal_16s_ease-in-out_1s_infinite]"></div>

			<div className="absolute top-[10%] left-[10%] w-[160px] h-[160px] rounded-full bg-teal opacity-20 blur-lg animate-[floatX_12s_ease-in-out_0.5s_infinite]"></div>

			<div className="absolute top-[5%] right-[10%] w-[200px] h-[200px] rounded-full bg-teal opacity-25 blur-lg animate-[circular_25s_linear_infinite]"></div>

			<div className="absolute top-[-2%] left-[3%] w-[200px] h-[200px] rounded-full bg-pistachio opacity-30 blur-xl animate-[diagonal_18s_ease-in-out_3s_infinite_reverse]"></div>

			<div className="absolute top-[40%] right-[10%] w-[150px] h-[150px] rounded-full bg-pistachio opacity-50 blur-lg animate-[float_11s_ease-in-out_2.5s_infinite_reverse]"></div>

			<div className="absolute top-[20%] left-[5%] w-[120px] h-[120px] rounded-full bg-pistachio opacity-50 blur-md animate-[floatX_14s_ease-in-out_1.2s_infinite]"></div>

			<div className="absolute top-[-80px] right-[-150px] w-[300px] h-[300px] rounded-full bg-pistachio opacity-40 blur-xl animate-[float_20s_ease-in-out_infinite]"></div>

			<div className="absolute bottom-50 left-40 w-[200px] h-[200px] rounded-full bg-teal opacity-50 blur-xl animate-[float_9s_ease-in-out_1.5s_infinite]"></div>

			{/* Main Content */}
			<div className="z-10 relative">
				<img
					src="/assets/icons/undraw/team.svg"
					alt="Error illustration"
					className="w-[500px] h-[500px] mb-4"
				/>
				<div className="max-w-md text-white text-3xl text-center mx-auto font-sans">
					{message}
				</div>
			</div>
		</div>
	);
};
export default ClientErrorMessage;
